// entities.js
import { reducer as attendanceReducer } from './event-attendance'
import { reducer as invitationsReducer } from './event-invitations'
import { reducer as questionsReducer } from './event-questions'
import { reducer as rosterPositionsReducer } from './event-roster-positions'

import cloneDeep from 'lodash.clonedeep'
import merge from 'lodash.merge'

// Actions
export const MERGE_ENTITIES = 'MERGE_ENTITIES'
export const CLEAR_ENTITIES = 'CLEAR_ENTITIES'

// Reducer
const initialState = {}

// little hack to combine reducers in a way that i want
export const reducer = (state = initialState, action) => {
    state = entitiesReducer(state, action)

    return {
        ...state,
        attendance: attendanceReducer(state.attendance, action),
        invitations: invitationsReducer(state.invitations, action),
        questions: questionsReducer(state.questions, action),
        rosterPositions: rosterPositionsReducer(state.rosterPositions, action),
    }
}

const entitiesReducer = (state, action) => {
    switch (action.type) {
        case MERGE_ENTITIES:
            return merge(cloneDeep(state), action.entities)
        case CLEAR_ENTITIES:
            return {}
        default:
            return state
    }
}

// Action Creators
export const mergeEntities = entities => ({
    type: MERGE_ENTITIES,
    entities,
})

export const clearEntities = () => ({
    type: CLEAR_ENTITIES,
})

// Thunks
